import { useTranslation } from 'react-i18next'
import { DetailSimpleCellProps } from '../types'

export const LivestockSimpleCell = ({ detail }: DetailSimpleCellProps) => {
  const { t } = useTranslation('@cibo/landmanager/LivestockSpecies')

  return <>{detail?.input?.species !== undefined ? t(`species_${detail.input.species}`) : '--'}</>
}
